// extracted by mini-css-extract-plugin
export var statItem = "_e7-1";
export var statsRow = "_e7-0";